import { httpCreators, HttpResponse } from 'rbh-merchant-core';
import { put, takeLatest, call } from 'redux-saga/effects';
import { MartProductService } from './martProduct-service';
import {
  MART_PRODUCT_INLINE_ERROR,
  MART_PRODUCT_REQUEST_ID_LIST,
  MART_PRODUCT_TRANSLATION_KEY
} from './martProduct-constant';
import { generalCreators } from '../../../../redux/general/general-action';
import { MODAL_TYPE } from '../../../../redux/general/general-constant';
import { GENERAL_STATE_KEY } from '../../../../redux/general/general-reducer';
import { generalSagas } from '../../../../redux/general/general-saga';
import { CallMartProductTncAction, MART_PRODUCT_ACTION_TYPE } from './martProduct-type';
import { martProductCreators } from './martProduct-action';
import { MART_PRODUCT_STATE_KEY } from './martProduct-reducer';
import { history } from '../../../../router';
import { noop } from 'lodash';
import { martCategorySagas } from '../../MartCategory/redux/martCategory-saga';

function* callMartProduct(action: CallMartProductTncAction) {
  const { data, isCallTnc } = action.payload;
  yield put(httpCreators.request({
    id: MART_PRODUCT_REQUEST_ID_LIST.POST_MART_PRODUCT_INQUIRY,
    sagaHandler: postMartProductInquiryHandler as any,
    service: MartProductService.postMartProductInquiry,
    serviceParams: data
  }));
  if (isCallTnc) {
    yield call(generalSagas.callTnc);
  }
}

function* postMartProductInquiryHandler(resp: HttpResponse) {
  if (resp.success) {
    yield put(martProductCreators.setMartProductState(MART_PRODUCT_STATE_KEY.MART_PRODUCT, resp.data.products as []));
    yield put(martProductCreators.setMartProductState(MART_PRODUCT_STATE_KEY.IS_POS_ACTIONED, resp.data.isPOSActioned));
    yield put(martProductCreators.setMartProductState(MART_PRODUCT_STATE_KEY.PRODUCT_TOTAL_ITEMS, resp.data.totalItems));
  } else {
    yield put(martProductCreators.setMartProductState(MART_PRODUCT_STATE_KEY.MART_PRODUCT, undefined));
  }
}

function* postPatchMartProductHandler(resp: HttpResponse, callbackParams: {
  onSuccessCallback: () => void,
  validateSku: () => void, setFieldError: (fieldName: string, errorShow: string[]) => void,
  clearFieldTagIsDeleted: () => void
}) {
  if (resp.success) {
    yield call(callbackParams.onSuccessCallback);
  } else if (resp.statusCode === 1799 && resp.data?.translationKey) {
    for (const key of resp.data?.translationKey) {
      if (key === MART_PRODUCT_TRANSLATION_KEY.PRODUCT_NAME_TH_DUP) {
        yield call(callbackParams.setFieldError, 'productNameTH', [MART_PRODUCT_INLINE_ERROR.PRODUCT_NAME_DUP]);
      } else if (key === MART_PRODUCT_TRANSLATION_KEY.PRODUCT_NAME_EN_DUP) {
        yield call(callbackParams.setFieldError, 'productNameEN', [MART_PRODUCT_INLINE_ERROR.PRODUCT_NAME_DUP]);
      }
    }
  } else if (resp.statusCode === 1899 && resp.data?.translationKey) {
    for (const key of resp.data?.translationKey) {
      if (key === MART_PRODUCT_TRANSLATION_KEY.PRODUCT_NAME_TH_INVALID) {
        yield call(callbackParams.setFieldError, 'productNameTH', [MART_PRODUCT_INLINE_ERROR.PRODUCT_NAME_TH_INVALID]);
      } else if (key === MART_PRODUCT_TRANSLATION_KEY.PRODUCT_NAME_EN_INVALID) {
        yield call(callbackParams.setFieldError, 'productNameEN', [MART_PRODUCT_INLINE_ERROR.PRODUCT_NAME_EN_INVALID]);
      } else if (key === MART_PRODUCT_TRANSLATION_KEY.PRODUCT_DESC_TH_INVALID) {
        yield call(callbackParams.setFieldError, 'productDescriptionTH', [MART_PRODUCT_INLINE_ERROR.PRODUCT_DESC_TH_INVALID]);
      } else if (key === MART_PRODUCT_TRANSLATION_KEY.PRODUCT_DESC_EN_INVALID) {
        yield call(callbackParams.setFieldError, 'productDescriptionEN', [MART_PRODUCT_INLINE_ERROR.PRODUCT_DESC_EN_INVALID]);
      } else if (key === MART_PRODUCT_TRANSLATION_KEY.PRODUCT_SKU_ID_INVALID) {
        yield call(callbackParams.setFieldError, 'productSKUId', [MART_PRODUCT_INLINE_ERROR.PRODUCT_SKU_ID_INVALID]);
      } else if (key === MART_PRODUCT_TRANSLATION_KEY.PRODUCT_SKU_ID_REQUIRED) {
        yield call(callbackParams.validateSku);
      } else if (key === MART_PRODUCT_TRANSLATION_KEY.PRODUCT_CATEGORY_NOT_FOUND) {
        yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
          visible: true,
          modalTitle: 'main.mart.product.add.form.error.notFoundCategory.title',
          modalContent: 'main.mart.product.add.form.error.notFoundCategory.content',
          onOk: noop,
          type: MODAL_TYPE.ERROR
        }));
      } else if (key === MART_PRODUCT_TRANSLATION_KEY.TAG_NOT_FOUND) {
        yield call(callbackParams.clearFieldTagIsDeleted);
        yield call(martCategorySagas.getMartTag);
      } else if (key === MART_PRODUCT_TRANSLATION_KEY.PRODUCT_PRICE_INVALID) {
        yield call(callbackParams.setFieldError, 'productPrice', [MART_PRODUCT_INLINE_ERROR.PRODUCT_PRICE_INVALID]);
      } else if (key === MART_PRODUCT_TRANSLATION_KEY.START_DATE_TIME_INVALID) {
        yield call(callbackParams.setFieldError, 'promoStartDateTime', [MART_PRODUCT_INLINE_ERROR.PROMO_START_DATETIME_INVALID]);
      } else if (key === MART_PRODUCT_TRANSLATION_KEY.END_DATE_TIME_INVALID) {
        yield call(callbackParams.setFieldError, 'promoEndDateTime', [MART_PRODUCT_INLINE_ERROR.PROMO_END_DATETIME_INVALID]);
      } else if (key === MART_PRODUCT_TRANSLATION_KEY.EXCEED_MAX_START_DATE_TIME) {
        yield call(callbackParams.setFieldError, 'promoStartDateTime', [MART_PRODUCT_INLINE_ERROR.PROMO_START_DATETIME_EXCEED]);
      } else if (key === MART_PRODUCT_TRANSLATION_KEY.EXCEED_MAX_END_DATE_TIME) {
        yield call(callbackParams.setFieldError, 'promoEndDateTime', [MART_PRODUCT_INLINE_ERROR.PROMO_END_DATETIME_EXCEED]);
      } else if (key === MART_PRODUCT_TRANSLATION_KEY.SAME_DATE_TIME) {
        yield call(callbackParams.setFieldError, 'promoEndDateTime', [MART_PRODUCT_INLINE_ERROR.PROMO_SAME_DATETIME]);
      }
    }
  } else if (resp.statusCode === 1899) {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: () => {
        history.push('/main/martproduct');
      },
      type: MODAL_TYPE.ERROR
    }));
  } else {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: noop,
      type: MODAL_TYPE.ERROR
    }));
  }
}

function* deleteMartProductHandler(resp: HttpResponse, callbackParams: any) {
  if (resp.success) {
    yield call(callbackParams);
    yield put(martProductCreators.setMartProductState(MART_PRODUCT_STATE_KEY.IS_ALERT_SUCCESS, true));
  } else if (resp.statusCode === 1899 && resp.data?.translationKey) {
    for (const key of resp.data?.translationKey) {
      if (key === MART_PRODUCT_TRANSLATION_KEY.PRODUCT_NOT_FOUND) {
        yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
          visible: true,
          onOk: () => {
            callbackParams();
          },
          type: MODAL_TYPE.ERROR
        }));
      }
    }
  } else if (resp.statusCode === 1899) {
    yield call(callbackParams);
    yield put(martProductCreators.setMartProductState(MART_PRODUCT_STATE_KEY.IS_ALERT_FAILURE, true));
  } else {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: noop,
      type: MODAL_TYPE.ERROR
    }));
  }
}

function* getBasketLimitHandler(resp: HttpResponse, callbackParams: { productCharacteristic: any, afterClose: () => void }) {
  if (resp.success) {
    yield put(martProductCreators.setMartProductState(MART_PRODUCT_STATE_KEY.PRODUCT_WEIGHT_UNIT, resp.data.productWeightUnit as []));
    yield put(martProductCreators.setMartProductState(MART_PRODUCT_STATE_KEY.PRODUCT_SIZE, resp.data.productSize as []));
    yield put(martProductCreators.setMartProductState(MART_PRODUCT_STATE_KEY.PRODUCT_AMOUNT_CONFIG, resp.data.productAmountConfig));
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      escClosable: false,
      clickClosable: false,
      ...callbackParams.productCharacteristic,
      type: MODAL_TYPE.PRODUCT_LIMIT,
      afterClose: callbackParams.afterClose,
    }));
  } else {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: noop,
      type: MODAL_TYPE.ERROR
    }));
  }
}

function* postCalculateProductOrderLimitWeightHandler(resp: HttpResponse) {
  if (resp.success) {
    yield put(martProductCreators.setMartProductState(MART_PRODUCT_STATE_KEY.PRODUCT_CALCULATED_WEIGHT, resp.data));
    yield put(martProductCreators.setMartProductState(MART_PRODUCT_STATE_KEY.IS_EDIT_BASKET_LIMIT, true));
  } else {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: noop,
      type: MODAL_TYPE.ERROR
    }));
  }
}

function* postCalculateProductOrderLimitSizeHandler(resp: HttpResponse) {
  if (resp.success) {
    yield put(martProductCreators.setMartProductState(MART_PRODUCT_STATE_KEY.PRODUCT_CALCULATED_SIZE, resp.data));
    yield put(martProductCreators.setMartProductState(MART_PRODUCT_STATE_KEY.IS_EDIT_BASKET_LIMIT, true));
  } else {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: noop,
      type: MODAL_TYPE.ERROR
    }));
  }
}

export const martProductSagas = {
  callMartProduct,
  postMartProductInquiryHandler,
  postPatchMartProductHandler,
  deleteMartProductHandler,
  getBasketLimitHandler,
  postCalculateProductOrderLimitWeightHandler,
  postCalculateProductOrderLimitSizeHandler,
  watchers: [
    takeLatest(MART_PRODUCT_ACTION_TYPE.CALL_MART_PRODUCT_TNC, callMartProduct)
  ]
};
